import { useState } from "react";
import { Button } from "V2.0/common/button";
import { PlusIcon } from "@heroicons/react/24/outline";
import WebhookTable from "./WebhookTable";
import WebhookFormDialog from "./WebhookFormDialog";

export default Webhook;

function Webhook(props) {
  const { webhooks, onWebhookAdd, onWebhookUpdate, onWebhookRemove } = props;

  const [webhookFormDialog, setWebhookFormDialog] = useState({
    mode: undefined,
    webhook: undefined,
    webhookIdx: -1,
  });

  const handleCloseWebhookFormDialog = () => setWebhookFormDialog({
    mode: undefined,
    webhook: undefined,
    webhookIdx: -1,
  });

  const handleWebhookFormEdit = (webhook, webhookIdx) =>
    setWebhookFormDialog({
      mode: "edit",
      webhook,
      webhookIdx,
    });

  const handleWebhookFormAdd = () => {
    setWebhookFormDialog({
      mode: "add",
      webhook: undefined,
      webhookIdx: -1,
    });
  };

  return (
    <>
      <div>
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium">Webhook</p>
          <Button
            plain
            onClick={handleWebhookFormAdd}
          >
            <PlusIcon /> Add
          </Button>
        </div>
        <WebhookTable
          webhooks={webhooks}
          onEditWebhook={handleWebhookFormEdit}
          onRemoveWebhook={onWebhookRemove}
        />
      </div>
      {webhookFormDialog.mode && (
        <WebhookFormDialog
          state={webhookFormDialog}
          onWebhookAdd={onWebhookAdd}
          onWebhookUpdate={onWebhookUpdate}
          onClose={handleCloseWebhookFormDialog}
        />
      )}
    </>
  );
}
